import { Box, Grid, List, ListItem, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import ChargeUsageStatue from "../dashboard/ChargeUsageStatue";
import { useSubscription } from "@apollo/client";
import { API_PORTS_SUBSCRIPTION } from "../../graphql/query";
import ChargerOperationStatus from "./ChargerOperationStatus";
import RegisteredFacility from "./RegisterdFacility";
import { BharatacOn } from "./icons/BHARATAC-on";
import { Ccs1On } from "./icons/CCS1-on";
import { Cccs2On } from "./icons/CCS2-on";
import { ChademoOn } from "./icons/CHADEMO-on";
import { GbtOn } from "./icons/GBT-on";
import { PlugpointOn } from "./icons/PLUGPOINT-on";
import { TeslaOn } from "./icons/TESLA-on";
import { Type1on } from "./icons/TYPE1-on";
import { Type2On } from "./icons/TYPE2-on";
import ProfileSection from "../ProfileSection";
import BharatdcOn from "./icons/BHARATDC-on.svg";
import FacilityFilterBtn from "../FacilityFilter";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import CustomModal from "../customComponents/customModal";
import CustomTabs from "../customComponents/CustomTabs";
import ExportExcel from "../buttonComponents/ExportExcel";
import DynamicTable from "../customComponents/DynamicTable";
import * as XLSX from "xlsx";

export default function StationManagement() {
  const { selectedFacility } = useSelector((state) => state.stationList);
  const [chargerDetails, setChargerDetails] = useState(null);
  const [boxColor, setBoxColor] = useState("white");

  const { t } = useTranslation();

  const { data } = useSubscription(API_PORTS_SUBSCRIPTION, {
    variables: {
      where: {
        api_charger: {
          api_facility: {
            ...(selectedFacility?.id && {
              id: {
                _in: [
                  ...(typeof selectedFacility?.id === "number"
                    ? [selectedFacility?.id]
                    : selectedFacility?.id),
                ],
              },
            }),
          },
        },
      },
    },
  });

  const typeIconMap = {
    TYPE2: <Type2On />,
    TYPE1: <Type1on />,
    BHARATAC: <BharatacOn />,
    PLUGPOINT: <PlugpointOn />,
    CCS1: <Ccs1On />,
    CCS2: <Cccs2On />,
    BHARATDC: (
      <img src={BharatdcOn} alt="bharatdc" width="20px" height="20px" />
    ),
    TESLA: <TeslaOn />,
    CHADEMO: <ChademoOn />,
    GBT: <GbtOn />,
  };

  useEffect(() => {
    if (data?.api_chargerport) {
      const chargerByTypes = [];
      data?.api_chargerport.forEach((p) => {
        const typeIndex = chargerByTypes.findIndex(
          (t) => t.label === p.port_type
        );
        if (typeIndex === -1) {
          chargerByTypes.push({
            label: p.port_type,
            value: 1,
            svg: typeIconMap[p.port_type],
            table: data?.api_chargerport
              .filter((port) => port.port_type === p.port_type)
              .map((port) => ({
                charger_name: port.api_charger.name,
                connector_id: port.connector_id,
                facility_name: port.api_charger.api_facility.name,
                last_updated_at: port.updated_at,
                power_type: port.power_type,
              })),
            index: 0,
          });
        } else {
          chargerByTypes[typeIndex].value = chargerByTypes[typeIndex].value + 1;
        }
      });

      setChargerDetails(chargerByTypes);
    }
  }, [data, selectedFacility]);

  const [tab, setTab] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [tableData, setTableData] = useState(null);

  const openStatusModal = (e, d) => {
    setTab(d);
    setOpenModal(true);
  };

  function formatDate(date) {
    let dd = String(date.getDate()).padStart(2, "0");
    let mm = String(date.getMonth() + 1).padStart(2, "0"); // January is 0!
    let yyyy = date.getFullYear();
    let hh = String(date.getHours()).padStart(2, "0");
    let min = String(date.getMinutes()).padStart(2, "0");
    let ss = String(date.getSeconds()).padStart(2, "0");

    return `${dd}-${mm}-${yyyy} ${hh}:${min}:${ss}`;
  }

  const formateTableData = (toFormateData) => {
    const formateData = (content, type) => {
      return content?.map((item) => ({
        charger_name: item?.charger_name,
        connector_id: item?.connector_id,
        facility_name: item?.facility_name,
        last_updated_at: item?.last_updated_at
          ? formatDate(new Date(item?.last_updated_at))
          : "",
        power_type: item?.power_type,
      }));
    };

    const headers = [
      { label: "charger", id: "charger_name" },
      { label: "connector id", id: "connector_id" },
      { label: "facility", id: "facility_name" },
      { label: "last updated at", id: "last_updated_at" },
      { label: "charger type", id: "power_type" },
    ];

    setTableData({
      type: "table",
      name: null,
      tabs: toFormateData.map((item) => ({
        name: item.label,
        headers: headers,
        table_content: formateData(item.table, item.label),
        count: item.table?.length ?? 0,
      })),
    });
  };

  useEffect(() => {
    if (chargerDetails?.length > 0) formateTableData(chargerDetails);
  }, [chargerDetails]);

  const handleExportExcel = () => {
    if (!tableData || !tableData?.tabs) return;

    const workbook = XLSX.utils.book_new();
    tableData?.tabs?.forEach((tab) => {
      if (tab.table_content.length > 0) {
        const filteredData = tab.table_content.map(
          ({
            charger_name,
            connector_id,
            facility_name,
            last_updated_at,
            power_type,
          }) => ({
            charger: charger_name,
            "connector id": connector_id,
            facility: facility_name,
            "last updated at": last_updated_at,
            charger_type: power_type,
          })
        );

        const worksheet = XLSX.utils.json_to_sheet(filteredData);
        XLSX.utils.book_append_sheet(workbook, worksheet, tab.name);
      }
    });
    if (workbook.SheetNames.length > 0)
      XLSX.writeFile(workbook, `Charger_types.xlsx`);
  };

  return (
    <Box sx={{ flexBasis: 1, padding: "0px 0" }}>
      <Box>
        <Grid
          container
          rowSpacing={3}
          columnSpacing={3}
          alignItems="center"
          style={{ backgroundColor: "white", marginBottom: "20px" }}
        >
          <Grid
            item
            xs={8}
            style={{
              flexGrow: 1,
              padding: "0 20px",
              alignItems: "center",
              display: "flex",
            }}
          >
            <Typography variant="h4" fontSize="20px" fontWeight="600">
              {t("stationManagementOverview")}
            </Typography>
          </Grid>
          <Grid item xs={4} style={{ paddingTop: "5px" }}>
            <ProfileSection />
          </Grid>
        </Grid>
        <Grid container justifyContent="space-between" mb={2}>
          <Grid item>
            <FacilityFilterBtn />
          </Grid>
        </Grid>
        <Grid
          container
          sx={{
            flexWrap: { md: "nowrap", xs: "wrap" },
            flexDirection: { md: "column", lg: "row" },
            gap: "20px",
          }}
        >
          <Grid item lg={8} xs={12} display="flex" flexDirection="column">
            <ChargerOperationStatus
              boxColor={boxColor}
              facilityFilter={selectedFacility}
            />
            <RegisteredFacility
              boxColor={boxColor}
              facilityFilter={selectedFacility}
            />
          </Grid>
          <Grid
            item
            lg={4}
            xs={12}
            sx={{ display: "flex", flexDirection: "column" }}
          >
            {chargerDetails && (
              <Grid
                item
                sx={{
                  backgroundColor: boxColor,
                  padding: "10px 20px",
                  borderRadius: "16px",
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "column",
                  marginBottom: "24px",
                }}
              >
                <Typography
                  variant="h5"
                  component="h5"
                  sx={{
                    wordBreak: "break-all",
                    marginBottom: "24px",
                    fontWeight: "600",
                    fontSize: "20px",
                  }}
                >
                  {t("chargerType")}
                </Typography>
                <List
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    padding: "0",
                  }}
                >
                  {chargerDetails
                    ?.filter((item) => item.value > 0)
                    .map((item, index) => (
                      <ListItem
                        key={`chargeport-${index}`}
                        sx={{
                          marginBottom: "14px",
                          padding: "0",
                          cursor: "pointer",
                        }}
                        onClick={(e) => openStatusModal(e, item?.index)}
                      >
                        <Grid
                          container
                          justifyContent="space-between"
                          flexWrap="nowrap"
                          alignItems="center"
                        >
                          <Grid
                            item
                            sx={{
                              display: "flex",
                              gap: "10px",
                              alignItems: "center",
                            }}
                          >
                            <Grid
                              item
                              sx={{
                                width: "20px",
                                height: "20px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              {item?.svg}
                            </Grid>
                            <Typography
                              variant="overline"
                              sx={{
                                lineHeight: "18px",
                                fontSize: "14px",
                                fontWeight: "500",
                                color: "#5C677D",
                              }}
                            >
                              {item?.label}
                            </Typography>
                          </Grid>
                          <Grid item>
                            <Typography
                              variant="subtitle2"
                              component="span"
                              sx={{
                                lineHeight: "18px",
                                fontSize: "14px",
                                fontWeight: "500",
                                color: "#001233",
                              }}
                            >
                              {item?.value}
                            </Typography>
                          </Grid>
                        </Grid>
                      </ListItem>
                    ))}
                </List>
              </Grid>
            )}
            <Grid
              item
              sx={{
                display: "flex",
                flexDirection: "column",
                backgroundColor: boxColor,
                borderRadius: "16px",
                padding: "20px",
                alignItems: { lg: "normal", xs: "center" },
              }}
            >
              <ChargeUsageStatue
                facilityFilterID={selectedFacility.id}
                facilityFilterName={selectedFacility.name}
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>
      {openModal && (
        <>
          <CustomModal
            open={openModal}
            onClose={() => setOpenModal(false)}
            bgColor="white"
            width="50vw"
            overflow="clip"
          >
            <Grid sx={{ paddingInline: "16px" }}>
              <CustomTabs
                formTabs={tableData?.tabs}
                tabValue={tab}
                handleTabChange={(e, newValue) => setTab(newValue)}
                showCount={true}
              />
            </Grid>
            <Grid container justifyContent="flex-start" m={2}>
              <ExportExcel key="10" onClick={handleExportExcel} />
            </Grid>
            <DynamicTable
              setSelectedData={setTab}
              tabValue={tab}
              searchedData={tableData?.tabs[tab]?.table_content}
              tabs={tableData?.tabs}
              maxHeight="calc(70vh - 145px)"
            />
          </CustomModal>
        </>
      )}
    </Box>
  );
}
